import { useEffect, useRef, useState } from "react";
import { api } from "../lib/api";
import PrintedTees from "../components/PrintedTees";
import TeeDropOpportunities from "../components/TeeDropOpportunities";
import TeeCohorts from "../components/TeeCohorts";
import CohortComparison from "../components/CohortComparison";
import TeePredictor from "../components/TeePredictor";
import RetentionAlerts from "../components/RetentionAlerts";
import DateRangePicker from "../components/DateRangePicker";
import StoreMultiSelect from "../components/StoreMultiSelect";
import FilterBar from "../components/FilterBar";
import { useAuth, homeStores } from "../context/AuthContext";

export default function Tees() {
  const [range, setRange] = useState(null);
  const { user } = useAuth();
  const [outlets, setOutlets] = useState([]);
  const [outletIds, setOutletIds] = useState(() => homeStores(user));
  const [pickerValue] = useState({
    state: { tab: "period", unit: "Week", mode: "previous_n", n: 3 },
    stateKey: 0,
  });

  useEffect(() => {
    api.get("/outlets").then(({ data }) => setOutlets(data)).catch(() => {});
  }, []);

  return (
    <div className="space-y-8" data-testid="tees-page">
      {/* Filter bar */}
      <section className="flex flex-wrap items-end justify-between gap-6">
        <div>
          <div className="bm-eyebrow text-neutral-500">Toronto · House-manufactured</div>
          <h1 className="text-2xl font-semibold tracking-tight mt-1">Printed Tees.</h1>
          <p className="bm-eyebrow text-neutral-500 mt-1 max-w-[520px]">
            Every #Printed Tee design — retention, cohorts, feature-wall picks and manager overrides in one place.
          </p>
        </div>
        <FilterBar summary={range?.label || ""} testId="tees-filter-toolbar">
          <StoreMultiSelect outlets={outlets} value={outletIds} onChange={setOutletIds} />
          <DateRangePicker value={pickerValue} onChange={setRange} />
        </FilterBar>
      </section>

      <div className="bm-hairline" />

      {/* Printed Tees table — first chart on the page */}
      <section>
        <PrintedTees range={range} outletIds={outletIds} />
      </section>

      {/* Claude drop-opportunity analysis */}
      <section>
        <TeeDropOpportunities range={range} />
      </section>

      {/* Restock signals */}
      <section>
        <RetentionAlerts />
      </section>

      {/* Tee cohorts (drop-month breakdown) */}
      <section>
        <TeeCohorts />
      </section>

      {/* Cohort comparison overlay */}
      <section>
        <CohortComparison />
      </section>

      {/* Printed Tee predictor (this week's wall) */}
      <section>
        <TeePredictor />
      </section>
    </div>
  );
}
